import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { NumericBox } from "../components/common/NumericBox";
import { TextArea } from "../components/common/TextArea";
import { TextBox } from "../components/common/TextBox";
import PopupContent from "../components/popupContent";
import { FormatString } from "../helpers/stringHelpers";
import TranslationContext from "../providers/TranslationContext";
import { ValidationProvider } from "../providers/ValidationContext";
import { addNotification } from "../redux/actions";
import { apiCreateOrUpdateDiscount, apiGetDiscountDetails } from "../services/DiscountsService";
import { validateForm } from "../validation/formValidation";
import { model } from "../validation/models/discount";
import PopupOperationsBar from "./PopupOperationsBar";
import CheckBox from "../components/common/CheckBox";
import { SelectBox } from "../components/common/SelectBox";

// styles
require("./PopupGeneralStyles.css");

interface Props {
    id?: number;
    handleCancel: any;
    refreshData: any;
    discountGroups: any[];
    sellerId?: number | null;
}

const DiscountPopup = (props: Props) => {
    const translationContext = useContext(TranslationContext) as any;
    const prefix = translationContext.prefix;
    const { t } = useTranslation(undefined, { keyPrefix: `${prefix}.Popup` });
    const { t: tDiscountMain } = useTranslation(undefined, { keyPrefix: `${prefix}` });
    const cloneDeep = require('clone-deep');
    const [validationModel, setValidationModel] = useState(cloneDeep(model));

    const [loading, setLoading] = useState(true);
    const data: any = { applicableTo: '0' };
    const [formData, setFormData] = useState(data);
    const [discountGroups, setDiscountGroups] = useState([]);
    const [saveError, setSaveError] = useState(false);

    const isEditMode = props.id ? true : false;

    const dispatch = useDispatch();

    useEffect(() => {
        if (props.id) {
            apiGetDiscountDetails(props.id)
                .then((responseData) => {
                    debugger;
                    responseData.data.discountGroups = responseData.data.discountGroups.map((group: any) => {
                        return { ...group, value: -group.value, clientId: group.id !== -1 ? `${group.id}` : `${group.discountId}_${group.groupId}` };
                    });
                    setFormData({
                        ...responseData.data, applicableTo: responseData.data.idProductsGroup,

                        discountBaseDekorativaDenas: - responseData.data.discountBaseDekorativaDenas,
                        discountBaseDekorativaBalt: - responseData.data.discountBaseDekorativaBalt,
                        discountBasePrumyslBaltHostemix: - responseData.data.discountBasePrumyslBaltHostemix,
                        discountBasePrumyslDenas: - responseData.data.discountBasePrumyslDenas,
                        discountBasePurlet: - responseData.data.discountBasePurlet,
                        discountBaseNezarazeno: - responseData.data.discountBaseNezarazeno
                    });
                    setLoading(false);
                })
                .catch((err: any) => {
                    dispatch(addNotification({ text: FormatString(t('LoadingDetailsError'), `${props.id}`), type: 'error' }));
                    props.handleCancel();
                });
        }
        else {
            const groups = props.discountGroups.map((group: any) => {
                return { ...group, clientId: group.id !== -1 ? `${group.id}` : `0_${group.groupId}` };
            });
            setFormData({
                discountGroups: groups
            });
        }
    }, []);

    const setCustomFormData = (dataField: any, id: any, value: any) => {
        let group = formData.discountGroups.find((g: any) => { return g.clientId === id });
        if (group) {
            group.value = value;
        }
    };

    const onAddingClick = () => {
        validateForm(validationModel, formData, isEditMode);
        setValidationModel({ ...validationModel });
        if (validationModel.isValid) {
            setLoading(true);
            if (props.sellerId) {
                formData.sellerId = props.sellerId;
            };

            // invert value for discountBase and groups
            let dataToSave = { ...formData };

            dataToSave.discountBaseDekorativaDenas = - dataToSave.discountBaseDekorativaDenas;
            dataToSave.discountBaseDekorativaBalt = - dataToSave.discountBaseDekorativaBalt;
            dataToSave.discountBasePrumyslBaltHostemix = - dataToSave.discountBasePrumyslBaltHostemix;
            dataToSave.discountBasePrumyslDenas = - dataToSave.discountBasePrumyslDenas;
            dataToSave.discountBasePurlet = - dataToSave.discountBasePurlet;
            dataToSave.discountBaseNezarazeno = - dataToSave.discountBaseNezarazeno;

            if (dataToSave.discountGroups && dataToSave.discountGroups.length > 0) {
                dataToSave.discountGroups.forEach((group: any) => {
                    group.value = -group.value;
                })
            }

            apiCreateOrUpdateDiscount(dataToSave)
                .then((responseData) => {
                    dispatch(addNotification({ text: FormatString(t('CreateSuccess'), dataToSave.name), type: 'success' }));
                    props.refreshData();
                    props.handleCancel();

                    setLoading(false);
                })
                .catch((err: any) => {
                    dispatch(addNotification({ text: FormatString(t('CreateFailure'), dataToSave.name), type: 'error' }));
                    props.handleCancel();

                    setSaveError(true);
                });
        }
    };

    const onEditingClick = () => {

        validateForm(validationModel, formData, isEditMode);
        setValidationModel({ ...validationModel });
        debugger
        if (validationModel.isValid) {
            setLoading(true);

            // invert value for discountBase and groups
            let dataToSave = { ...formData };

            dataToSave.discountBaseDekorativaDenas = - dataToSave.discountBaseDekorativaDenas;
            dataToSave.discountBaseDekorativaBalt = - dataToSave.discountBaseDekorativaBalt;
            dataToSave.discountBasePrumyslBaltHostemix = - dataToSave.discountBasePrumyslBaltHostemix;
            dataToSave.discountBasePrumyslDenas = - dataToSave.discountBasePrumyslDenas;
            dataToSave.discountBasePurlet = - dataToSave.discountBasePurlet;
            dataToSave.discountBaseNezarazeno = - dataToSave.discountBaseNezarazeno;

            if (dataToSave.discountGroups && dataToSave.discountGroups.length > 0) {
                dataToSave.discountGroups.forEach((group: any) => {
                    group.value = -group.value;
                })
            }

            apiCreateOrUpdateDiscount(dataToSave)
                .then((responseData) => {
                    dispatch(addNotification({ text: FormatString(t('EditSuccess'), dataToSave.name), type: 'success' }));
                    props.refreshData();
                    props.handleCancel();

                    setLoading(false);
                })
                .catch((err: any) => {
                    dispatch(addNotification({ text: FormatString(t('EditFailure'), dataToSave.name), type: 'error' }));
                    setSaveError(true);
                });
        }
    };

    const onCancelClick = () => {
        props.handleCancel();
    };

    return (
        <PopupContent header={props.id ? t('EditLabel') : t('CreateLabel')}>
            <ValidationProvider value={validationModel}>
                <TextBox
                    dataField="sortOrder"
                    value={formData.sortOrder}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="sortOrder"
                    label={t('Labels.sortOrder')}
                    placeholder={t('Labels.sortOrderPlaceholder')}
                    disabled={false}
                    isNumber={true}
                    min={1}
                    max={1000}
                    step={1}
                    handleCheckedChange={(value) => {

                        if (value < 0) {
                            setFormData({ ...formData, sortOrder: 1 });
                            return;
                        }
                        let valueInvariant = value.toString().replace(',', '.');

                        setFormData({ ...formData, sortOrder: valueInvariant });
                    }}
                />


                <CheckBox
                    id="chkIsPrimary"
                    label={`${t('Labels.isPrimary')}`}
                    paddingLeft={"10px"}
                    handleCheckedChange={(checked) => {

                        if (checked) {
                            setFormData({ ...formData, 'isPrimary': checked, 'onlyForAdminSeller': false });
                        }
                        else {
                            setFormData({ ...formData, 'isPrimary': checked });
                        }
                    }}
                    defaultValue={formData.isPrimary}
                />


                <CheckBox
                    id="chkOnlyForAdmin"
                    label={`${t('Labels.onlyForAdmin')}`}
                    paddingLeft={"10px"}
                    handleCheckedChange={(checked) => {

                        if (formData.isPrimary) {
                            // primarni sleva nemuze byt jen pro admina, musi byt pro vsechny
                            setFormData({ ...formData, 'onlyForAdminSeller': checked, 'isPrimary': false });
                        }
                        else {
                            setFormData({ ...formData, 'onlyForAdminSeller': checked });
                        }
                    }}
                    defaultValue={formData.onlyForAdminSeller}
                />

                <TextBox
                    dataField="name"
                    value={formData.name}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="name"
                    label={t('Labels.name')}
                    placeholder={t('Labels.namePlaceholder')}
                    disabled={false}
                />

                <NumericBox
                    dataField="discountBaseDekorativaBalt"
                    defaultValue={formData.discountBaseDekorativaBalt}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="discountBaseDekorativaBalt"
                    label={t('Labels.discountBaseDekorativaBalt')}
                    decimalPlaces={2}
                />

                <NumericBox
                    dataField="discountBaseDekorativaDenas"
                    defaultValue={formData.discountBaseDekorativaDenas}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="discountBaseDekorativaDenas"
                    label={t('Labels.discountBaseDekorativaDenas')}
                    decimalPlaces={2}
                />

                <NumericBox
                    dataField="discountBasePrumyslBaltHostemix"
                    defaultValue={formData.discountBasePrumyslBaltHostemix}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="discountBasePrumyslBaltHostemix"
                    label={t('Labels.discountBasePrumyslBaltHostemix')}
                    decimalPlaces={2}
                />

                <NumericBox
                    dataField="discountBasePrumyslDenas"
                    defaultValue={formData.discountBasePrumyslDenas}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="discountBasePrumyslDenas"
                    label={t('Labels.discountBasePrumyslDenas')}
                    decimalPlaces={2}
                />

                <NumericBox
                    dataField="discountBasePurlet"
                    defaultValue={formData.discountBasePurlet}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="discountBasePurlet"
                    label={t('Labels.discountBasePurlet')}
                    decimalPlaces={2}
                />

                <NumericBox
                    dataField="discountBaseNezarazeno"
                    defaultValue={formData.discountBaseNezarazeno}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="discountBaseNezarazeno"
                    label={t('Labels.discountBaseNezarazeno')}
                    decimalPlaces={2}
                />

                {isEditMode && formData?.discountGroups?.map((group: any) => {
                    return (
                        <NumericBox
                            dataField={`group${group.groupName}`}
                            defaultValue={group.value}
                            formData={formData}
                            setCustomStateMethod={setCustomFormData}
                            id={group.id !== -1 ? `${group.id}` : `${group.discountId}_${group.groupId}`}
                            label={`${group.groupName}`}
                            decimalPlaces={2}
                        />
                    )
                })}

                {!isEditMode && props.discountGroups?.map((group: any) => {
                    return (
                        <NumericBox
                            dataField={`group${group.groupName}`}
                            defaultValue={group.value}
                            formData={formData}
                            setCustomStateMethod={setCustomFormData}
                            id={group.id !== -1 ? `${group.id}` : `0_${group.groupId}`}
                            label={`${group.groupName}`}
                            decimalPlaces={2}
                        />
                    )
                })}

                <div style={{ color: 'orange', display: 'block', fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px' }}>
                    {t('DiscountInfo')}
                </div>

                <TextArea
                    id="noteInternal"
                    label={t('Labels.note')}
                    placeholder={t('Labels.notePlaceholder')}
                    rows={4}
                    dataField="noteInternal"
                    value={formData.noteInternal}
                    formData={formData}
                    setStateMethod={setFormData}
                />

                <PopupOperationsBar
                    handleAdding={onAddingClick}
                    handleCancellation={onCancelClick}
                    handleEditing={onEditingClick}
                    id={props.id}
                />
            </ValidationProvider>
        </PopupContent>
    );
};

export default DiscountPopup;